import { useEffect, useRef, type ReactNode } from 'react';

/**
 * The frame of a document's own screen, opened from its list: back, what it
 * is and what can be done stay pinned while the document scrolls. Shared by
 * every stock tab, the Items Manager and Offline work, with the `.docpage` styles.
 */
export function DocumentFrame({
  onBack,
  backLabel,
  title,
  actions,
  children,
}: {
  onBack: () => void;
  /** "Back to Stock IN": says where the button goes. */
  backLabel: string;
  title?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}) {
  const root = useRef<HTMLDivElement>(null);
  // Opened from a list or a long form scrolled down: the page starts at its top.
  useEffect(() => {
    root.current?.closest('.canvas')?.scrollTo?.(0, 0);
  }, []);
  return (
    <div className="workbench" ref={root}>
      <div className="docpage">
        {/* The click that opened this screen can be the first of a habitual
            double-click; the second must not land on Post or Delete. */}
        <header
          className="docpage__head"
          onClickCapture={(e) => {
            if (e.detail > 1) e.stopPropagation();
          }}
        >
          <div className="docpage__back">
            <button type="button" className="btn btn--sm btn--ghost btn--withicon" onClick={onBack}>
              <span aria-hidden="true">←</span> {backLabel}
            </button>
          </div>
          {title && <div className="docpage__title">{title}</div>}
          {actions && <div className="docpage__actions">{actions}</div>}
        </header>
        <div className="docpage__body">{children}</div>
      </div>
    </div>
  );
}
